import { render, staticRenderFns } from "./StartMedModal.vue?vue&type=template&id=c2458fea&scoped=true"
import script from "./StartMedModal.vue?vue&type=script&lang=js"
export * from "./StartMedModal.vue?vue&type=script&lang=js"
import style0 from "./StartMedModal.vue?vue&type=style&index=0&id=c2458fea&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2458fea",
  null
  
)

export default component.exports